import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/Sales/stocks'

export default {
  namespaced: true,
  state: {
    loading: false,
    lastMonth: {
      data: [],
      grandTotals: {
        today: 0,
        lastMonth: 0,
        chartData: {
          totalChart: {
            series: [],
            labels: [],
          },
          detailTotal: {
            series: [],
            labels: [],
          },
        },
      },
    },
    allocations: {
      data: [],
      grandTotals: {
        count: 0,
        chartData: {
          series: [],
          labels: [],
        },
      },
    },
    dayDurations: {
      data: [],
      grandTotals: {
        total: 0,
        total_count: 0,
        connected: 0,
        days_0_30: 0,
        days_31_60: 0,
        days_61: 0,
        value_date: 0,
        chart: {
          series: [],
          labels: [],
        },
      },
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    lastMonth(state) {
      return state.lastMonth
    },
    allocations(state) {
      return state.allocations
    },
    dayDurations(state) {
      return state.dayDurations
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_LAST_MONTH(state, data) {
      state.lastMonth = data
    },
    SET_ALLOCATIONS(state, data) {
      state.allocations = data
    },
    SET_DAY_DURATIONS(state, data) {
      state.dayDurations = data
    },
    /* RESET MUTATIONS */
    RESET_LAST_MONTH(state) {
      state.lastMonth = {
        data: [],
        grandTotals: {
          today: 0,
          lastMonth: 0,
          chartData: {
            totalChart: {
              series: [],
              labels: [],
            },
            detailTotal: {
              series: [],
              labels: [],
            },
          },
        },
      }
    },
    RESET_ALLOCATIONS(state) {
      state.allocations = {
        data: [],
        grandTotals: {
          count: 0,
          chartData: {
            series: [],
            labels: [],
          },
        },
      }
    },
    RESET_DAY_DURATIONS(state) {
      state.dayDurations = {
        data: [],
        grandTotals: {
          total: 0,
          total_count: 0,
          connected: 0,
          days_0_30: 0,
          days_31_60: 0,
          days_61: 0,
          value_date: 0,
        },
      }
    },
  },
  actions: {
    getLastMonth({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_LAST_MONTH')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/lastMonth`, data)
        .then(response => {
          commit('SET_LAST_MONTH', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getAllocations({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_ALLOCATIONS')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/allocations`, data)
        .then(response => {
          commit('SET_ALLOCATIONS', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getDaydurations({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_DAY_DURATIONS')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/daydurations`, data)
        .then(response => {
          commit('SET_DAY_DURATIONS', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
